var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1CA2BB;}\n\t.st1{fill:#EAC100;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2_3D_Printing"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1_VR_Gear"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0_Virtual_reality"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x39__Augmented_reality"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x38__Teleport"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x37__Glassess"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x36__Folding_phone"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x35__Drone"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x34__Retina_scan"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x33__Smartwatch"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x32__Bionic_Arm"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x31__Chip"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 48,
    width: 32,
    x: 48,
    y: 36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20,
    cy: 28,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20,
    cy: 92,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 108,
    cy: 52,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 96,
    cy: 100,
    r: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108,40c-5.2,0-9.6,3.3-11.3,8H84V32h-8V20h-8v12h-8V20h-8v12h-8v16H24v-8.7c4.7-1.7,8-6.1,8-11.3c0-6.6-5.4-12-12-12     S8,21.4,8,28c0,5.2,3.3,9.6,8,11.3V56h28v8H16v16.7c-4.7,1.7-8,6.1-8,11.3c0,6.6,5.4,12,12,12s12-5.4,12-12c0-5.2-3.3-9.6-8-11.3     V72h20v16h8v12h8V88h8v12h8V88h8V72h8v16.7c-4.7,1.7-8,6.1-8,11.3c0,6.6,5.4,12,12,12s12-5.4,12-12c0-5.2-3.3-9.6-8-11.3V64H84     v-8h12.7c1.7,4.7,6.1,8,11.3,8c6.6,0,12-5.4,12-12S114.6,40,108,40z M20,24c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S17.8,24,20,24     z M20,96c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S22.2,96,20,96z M96,104c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S98.2,104,96,104z      M76,80H52V40h24V80z M108,56c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S110.2,56,108,56z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    width: 8,
    x: 56,
    y: 64
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSources);
export default __webpack_public_path__ + "static/media/sources.e804c0bacf76f9af3bb47132b548c3a4.svg";
export { ForwardRef as ReactComponent };